module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CN ParaOverride-8",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Quarrels over women are the keynote of the New Guinea primitive world.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("—Margaret Mead")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Experience, contrary to common belief, is mostly imagination.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("—Ruth Benedict")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ebcebd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook42766.vue
// module id = 81
// module chunks = 0